import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollBy({
            top: -window.scrollY,
            behavior: 'smooth',
        });
    }, [pathname]);

    return null;
};
